import { CampaignReportView, GrowthDashboardTopBarActions } from '@elva/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useCampaignReport, useCampaignReportMutations } from '../hooks/useCampaignReport';

export function CampaignReportPage() {
  const { campaignId = '' } = useParams();
  const navigate = useNavigate();

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useCampaignReport(campaignId);
  const { pause, exportReport } = useCampaignReportMutations(campaignId);

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <CampaignReportView
        {...viewProps({
          campaignId,
          data: data ?? undefined,
          loading: isFetching,
          onBack: () => navigate('/campaigns'),
          onPause: () => pause.mutate(),
          onExport: () => exportReport.mutate(),
        })}
      />
    </AsyncBoundary>
  );
}
